<template>
  <div id="mapOL">
  </div>
</template>

<script>
  import axios from 'axios';

  import Map from 'ol/Map.js';
  import View from 'ol/View.js';
  import TileLayer from 'ol/layer/Tile.js'
  import OSM from "ol/source/OSM"
  import Feature from "ol/Feature.js"
  import Point from "ol/geom/Point.js"
  import VectorSource from "ol/source/Vector.js"
  import VectorLayer from "ol/layer/Vector.js"
  import Style from "ol/style/Style.js"
  import Icon from "ol/style/Icon.js"
  import {fromLonLat} from "ol/proj.js"

  function add_map_point(map, lat, lng) {
    var marker = new Feature({
      geometry: new Point(fromLonLat([lng, lat]))
    });

    var marker_shadow = new Feature({
      geometry: new Point(fromLonLat([lng, lat]))
    });

    marker.setStyle(new Style({
      image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        src: 'https://unpkg.com/leaflet@1.3.3/dist/images/marker-icon.png'
      }),
      zIndex: 200
    }));

    marker_shadow.setStyle(new Style({
      image: new Icon({
        anchor: [0.3, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        src: 'https://unpkg.com/leaflet@1.3.3/dist/images/marker-shadow.png'
      })
    }));

    var vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: [marker, marker_shadow]
      })
    });
    // console.log("Adding point")
    // var vectorLayer = new VectorLayer({
    //   source: new VectorSource({
    //     features: [new Feature({
    //       geometry: new Point(
    //         fromLonLat([lng, lat]))
    //     })]
    //   }),
    //   style: new Style({
    //     image: new Icon({
    //       anchor: [0.5, 1],
    //       anchorXUnits: "fraction",
    //       anchorYUnits: "fraction",
    //       src: 'https://unpkg.com/leaflet@1.3.3/dist/images/marker-icon.png',
    //       // src: 'https://unpkg.com/leaflet@1.3.3/dist/images/marker-shadow.png',
    //       scale: 0.9
    //       // src: process.env.BASE_URL + "img/location-pin.svg",
    //       // opacity: 0.8,e)
        //   return;
    //       // scale: 0.08
    //     })
    //   })
    // });
    map.addLayer(vectorLayer);
  }

  export default {
    name: "map-openlayers",
    props: {
      address: String
    },
    data() {return {
      coords: [],
      lat: 0,
      lon: 0
    }},
    watch: {
      address(/*oldValue, newValue*/) {
        // if(oldValue == newValue)
        //   return;
        this.fetchCoords()
      }
    },

    methods: {
      createMap() {
        var map = new Map({
          target: 'mapOL',
          layers: [
            new TileLayer({source: new OSM()})
          ],
          view: new View({
            center: fromLonLat([this.lon,this.lat]),
            zoom: 8
          })
        });

        add_map_point(map, this.lat, this.lon);
      },
      fetchCoords() {
        // console.log("Fetching for ", this.address);
        const endpoint = 'https://nominatim.openstreetmap.org/search/';
        axios.get(endpoint,{
          params: {
            format: 'jsonv2',
            q: this.address
          }
        })
        .then(response => {
          this.coords = response.data;
          this.lat = parseFloat(response.data[0].lat);
          this.lon = parseFloat(response.data[0].lon);
          this.createMap();
        });
      }
    },
    mounted() {
      // this.fetchCoords();
    }
  }
</script>

<style scoped lang="stylus">
  @import "~ol/ol.css"
  #mapOL
    height 250px
</style>
